import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { GridFilterCellProps } from "@progress/kendo-react-grid";

const allText = "(All)";
const activeText = "Active";
const inactiveText = "Inactive";

export const ActiveFilter = (props: GridFilterCellProps) => {
    const data = [{ text: allText }, { text: activeText }, { text: inactiveText }];

    const onChange = (event: DropDownListChangeEvent) => {
        if (event.value.text === activeText) {
            props.onChange({
                value: activeText,
                operator: "isnull",
                syntheticEvent: event as any,
            });
        } else if (event.value.text === inactiveText) {
            props.onChange({
                value: inactiveText,
                operator: "isnotnull",
                syntheticEvent: event as any,
            });
        } else {
            props.onChange({
                value: null,
                operator: "",
                syntheticEvent: event as any,
            });
        }
    };

    const value = props.value ? data.find(x => x.text === props.value) : data[0];

    return (
        <div className="k-filtercell">
            <DropDownList
                data={data}
                onChange={onChange}
                value={value}
                textField={"text"}
                dataItemKey={"text"}
            />
        </div>
    );
};